import { includes, pluck } from 'ramda';

export const disableDiscountSelectButton = (_, extraProps) => {
  const { pricingIndex, discountOptions, beneficiaryIndex } = extraProps;

  const hasCoupleDiscount = includes('Remise couple', pluck('value', discountOptions));

  return beneficiaryIndex > 0 || hasCoupleDiscount || pricingIndex > 0;
};
